import Button, { GhostButton, GrayButton, NormalButton, RefreshButton } from '@components/General/Button';
import { TableCell } from '@mui/material';
import {} from "@styles/components/Components.module.css"
import styles from '@styles/screens/Solicitudes.module.css'
import { usePopup } from '@contexts/popupContext';
import React, { useEffect, useState } from 'react';
import { ReactComponent as SearchSVG } from '@assets/SVGs/PresenteeismTable/SearchSVG.svg';
import Image from '@components/General/Image';
import Table from '@components/General/Table';
import { Application } from '@core/Application';
import { LeaveAbsenseResponse, LeaveAbsenseService } from '@services/LeaveAbsenseService';
import {} from "@localization/Localization"
import { Logger } from '@utils/Logger';
import TextEntryPopup from '@components/General/TextEntryPopup';
import Dropdown, { DropdownItem } from '@components/General/Dropdown';
import { Description } from '@utils/DescriptionsHelper';

const columns = [
    {
      label: 'Colaborador'.localized(),
      dataKey: 'colaborador',
      size: '30%',
      style: {
         textAlign: 'left',
         paddingLeft: '24px'
      }
    },
    {
      label: 'Motivo'.localized(),
      dataKey: 'motivo',
      size: '15%',
      style: {
        textAlign: 'left'
      }
    },
    {
      label: 'Período'.localized(),
      dataKey: 'periodo',
      size: '20%'
    },
    {
      label: 'Días'.localized(),
      dataKey: 'dias',
      size: '10%'
    },
    {
      label: '',
      dataKey: 'space',
    },
    {
      label: '',
      dataKey: 'reject',
      size: '140px',
    },
    {
        label: '',
        dataKey: 'approve',
        size: '140px',
    }
];

const columnsProcessed = [
    {
      label: 'Colaborador'.localized(),
      dataKey: 'colaborador',
      size: '25%',
      style: {
         textAlign: 'left',
         paddingLeft: '24px'
      }
    },
    {
      label: 'Motivo'.localized(),
      dataKey: 'motivo',
      size: '15%',
      style: {
        textAlign: 'left'
      }
    },
    {
      label: 'Período'.localized(),
      dataKey: 'periodo',
      size: '20%'
    },
    {
      label: 'Días'.localized(),
      dataKey: 'dias',
      size: '10%'
    },
    {
      label: 'Fecha'.localized(),
      dataKey: 'fecha',
      size: '10%'
    },
    {
        label: 'Status'.localized(),
        dataKey: 'status',
        size: '10%'
      },
  ];

const pendingId = "pending"

const filters: Array<DropdownItem> = [
    { id: pendingId, description: 'Pendientes'.localized() },
    { id: 'processed', description: 'Procesadas'.localized() },
]

const TableRow = ({row, orgID, handleNavigation, fetchPendingLeaveRequests}) => {
    const {showPopup} = usePopup()

    const handleApproval = async (text: string) => {
        Logger.log("Approving leave request with ID: ", row.id)
        let httpClient = Application.shared().coreDependencies.httpClient

        let service = new LeaveAbsenseService(
            httpClient
        )

        let reasonText = text.length > 0 ? text : "Aprobada".localized()
        
        await service.approvePendingLeaveAbsenseRequest(row.id, reasonText)

    }

    const handleRejection = async (text: string) => {
        Logger.log("Rejecting leave request with ID: ", row.id)
        let httpClient = Application.shared().coreDependencies.httpClient

        let service = new LeaveAbsenseService(
            httpClient
        )
        let reasonText = text.length > 0 ? text : "Rechazada".localized()
        await service.rejectPendingLeaveAbsenseRequest(row.id, reasonText)
    }

    return (
        <React.Fragment>
            <TableCell component="th" scope="row" align='left'>
                <div className={styles['circle-mask']}  style={{width: '24px', height: '24px', marginRight: '10px', display: 'inline-block', verticalAlign: 'top'}}>
                    <Image src={row.photo || '/assets/Q.png'} alt="Profile Picture" isRound={true} style={{width: '100%', height: '100%'}}/>
                </div>
                <div style={{display: 'inline-block', color: '#101828', fontWeight: 'bold'}}>
                    {row.colaborador.capitalize()}
                </div>
            </TableCell>
            <TableCell align="left" className={styles['table-row']}>{row.motivo}</TableCell>
            <TableCell align="center" className={styles['table-row']}>{row.periodo}</TableCell>
            <TableCell align="center" className={styles['table-row']}>{row.dias}</TableCell>
            <TableCell align="center" className={styles['table-row']}></TableCell>
            <TableCell align="center" className={styles['action-cell']}>
                <div className={styles['button-container']}>
                        <GrayButton text={'Rechazar'.localized()} onClick={() => {
                            showPopup(() => 
                                <TextEntryPopup
                                    title={"Rechazar solicitud".localized()}
                                    message={`¿Estás seguro que quieres rechazar la solicitud?`.localized()}
                                    onConfirmClick={handleRejection}
                                    onSuccess={() => {
                                        fetchPendingLeaveRequests();
                                    } }
                                    successMessage={"Solicitud rechazada".localized()}
                                    errorMessage={"Error al rechazar solicitud...".localized()}
                                    confirmButtonText={"Rechazar".localized()}
                                    onCancelClick={undefined}
                                    cancelMessage={undefined} 
                                    placeholder={"Escribe un mensaje para el colaborador".localized()}
                                />, 
                                false
                            )
                        }
                    }/>
                </div>

            </TableCell>
            <TableCell align="center" className={styles['action-cell']}>
                <div className={styles['button-container']}>
                    <GhostButton text={'Aprobar'.localized()} onClick={() => {
                        showPopup(() => 
                            <TextEntryPopup
                                title={"Aprobar solicitud".localized()}
                                message={`¿Estás seguro que quieres aprobar la solicitud?`.localized()}
                                onConfirmClick={handleApproval}
                                onSuccess={() => {
                                    fetchPendingLeaveRequests();
                                } }
                                successMessage={"Solicitud aprobada correctamente!".localized()}
                                errorMessage={"Error al aprobar solicitud...".localized()}
                                confirmButtonText={"Aprobar".localized()}
                                onCancelClick={undefined}
                                cancelMessage={undefined} 
                                placeholder={"Escribe un mensaje para el colaborador".localized()}
                            />, 
                            false
                        )}
                    }/>
                </div>
            </TableCell>
        </React.Fragment>
    )
}

const TableRowProcessed = ({row, orgID, handleNavigation, fetchProcessedLeaveRequests}) => {
    return (
        <React.Fragment>
            <TableCell component="th" scope="row" align='left'>
                <div className={styles['circle-mask']}  style={{width: '24px', height: '24px', marginRight: '10px', display: 'inline-block', verticalAlign: 'top'}}>
                    <Image src={row.photo || '/assets/Q.png'} alt="Profile Picture" isRound={true} style={{width: '100%', height: '100%'}}/>
                </div>
                <div style={{display: 'inline-block', color: '#101828', fontWeight: 'bold'}}>
                    {row.colaborador.capitalize()}
                </div>
            </TableCell>
            <TableCell align="left" className={styles['table-row']}>{row.motivo}</TableCell>
            <TableCell align="center" className={styles['table-row']}>{row.periodo}</TableCell>
            <TableCell align="center" className={styles['table-row']}>{row.dias}</TableCell>
            <TableCell align="center" className={styles['table-row']}>{row.fecha}</TableCell>
            <TableCell align="center" className={`${styles['table-row']} ${styles['approved']}`}>
                {row.status}
            </TableCell>
        </React.Fragment>
    )
}


interface SolicitudesProps {
    orgID: string
    timezone: string
}


enum ViewState {
    viewingPendingItems = "pending",
    viewingProcessedItems = "processing",
}

export const Solicitudes = ({orgID, timezone}: SolicitudesProps) => {

    function rowTemplate(_index, row) {
        return (
            <TableRow row={row} orgID={orgID} handleNavigation={handleNavigation} fetchPendingLeaveRequests={fetchPendingLeaveRequests}/>
        );
    }

    function rowTemplateProcessed(_index, row) {
        return (
            <TableRowProcessed row={row} orgID={orgID} handleNavigation={handleNavigation} fetchProcessedLeaveRequests={fetchProcessedLeaveRequests}/>
        );
    }
    
    const {showPopup} = usePopup()
    const [requests, setRequests] = useState([]);
    const [processedRequests, setProcessedRequests] = useState([]);
    const [date, setDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [searchField, setSearchField] = useState('')
    const [dropdownSelectedItem, setDropdownSelectedItem] = useState<DropdownItem | null>(null)
    const [currentState, setCurrentState] = useState<ViewState>(ViewState.viewingPendingItems)

    useEffect(() => {
        console.log("Iniciando fetchPendingLeaveRequests")
        refreshData(currentState)
    },[orgID])

    const handleNavigation = (path, state) => {

    };

    const refreshData = (state: ViewState) => {

        if (state == ViewState.viewingPendingItems) {
            fetchPendingLeaveRequests()
        } else {
            fetchProcessedLeaveRequests()
        }
    }

    const handleDropdownSelect = (item: DropdownItem) => {
        const newState = item.id == pendingId ? ViewState.viewingPendingItems : ViewState.viewingProcessedItems
        Logger.log("Solicitudes", "new state: "+newState)
        let shouldReload = newState != currentState
        setCurrentState(newState)
        setDropdownSelectedItem(item)
        if (shouldReload) {
            refreshData(newState)
        }
    };

    const fetchPendingLeaveRequests = async () => {
        Logger.log("Solicitudes", "getting pending requests")
        setLoading(true)
        let httpClient = Application.shared().coreDependencies.httpClient
        try {

            let service = new LeaveAbsenseService(
                httpClient
            )
            
            const leaveAbsenseRequests = await service.getPendingLeaveAbsenseRequests(
                orgID
            )
            
            setRequests(transformData(leaveAbsenseRequests))
            setLoading(false)

        } catch (error) {
            console.error(error)
            setError('Error fetching leave requests. Please try again later.')
        } finally {
            setLoading(false)
        }
    }

    const fetchProcessedLeaveRequests = async () => {
        Logger.log("Solicitudes", "getting processed requests")
        setLoading(true)
        let httpClient = Application.shared().coreDependencies.httpClient
        try {

            let service = new LeaveAbsenseService(
                httpClient
            )
            
            const leaveAbsenseRequests = await service.getProcessedLeaveAbsenseRequests(
                orgID
            )
            
            setProcessedRequests(transformData(leaveAbsenseRequests))
            setLoading(false)

        } catch (error) {
            console.error(error)
            setError('Error fetching leave requests. Please try again later.')
        } finally {
            setLoading(false)
        }
    }

    const placeholderText = () => {
        if (searchField.length > 0) {
            return "No hay resultados para tu búsqueda.".localized()
        }

        return currentState == ViewState.viewingPendingItems ? 
            "No hay solicitudes pendientes, buen trabajo! 😃".localized() :
            "No hay solicitudes procesadas todavía.".localized()
    }

    const transformData = (data: Array<LeaveAbsenseResponse>) => {
        let result = []
        data.forEach((row) => {
            result.push({
                id: row.request.id,
                colaborador: row.user.name,
                photo: row.user.image,
                motivo: row.reasonDescription,
                dias: row.days,
                periodo: row.request.fromDate +" al ".localized()+ row.request.toDate,
                fecha: Description.Timestamp.timeAgoWithDate(row.request.timestamp, timezone),
                status: row.request.state.localized(),
                style: row.request.state == "APPROVED" ? 'approved' : 'rejected'
            })
        })
        console.log("Data transformada:")
        console.log(result)

        return result
    }

    
    return (
        <>
        <div className={styles['nomina-header']}>
            <div className={styles['search-bar']}>
                <div className={styles['svg-container']}>
                    <SearchSVG/>
                </div>

                <div className={styles['search-field-container']}>
                    <input type='text' placeholder='Search' className={styles['search-input']} onChange={e => {setSearchField(e.target.value)}}/>
                </div>
            </div>
            <div> 
                <RefreshButton onClick={() => {
                        fetchPendingLeaveRequests();
                    } } text="" />
            </div>
            <div className={styles['align-right']}>
                <Dropdown
                    items={filters}
                    defaultSelection={filters[0]}
                    onSelect={handleDropdownSelect}
                    placeholder={"Filtrar por estado".localized()}
                />
            </div> 
        </div>

        <div className={styles['table-container']}>
            {dropdownSelectedItem?.id === pendingId || dropdownSelectedItem === null ? (
                <Table
                    loading={loading}
                    dataForRows={
                        requests
                            .filter((responseRow) => {
                                return responseRow.colaborador
                                    .toLowerCase()
                                    .replace(/\s/g, "")
                                    .includes(searchField.toLowerCase().replace(/\s/g, ""));
                            })
                            .sort((a, b) => a.colaborador.localeCompare(b.colaborador))
                    }
                    columns={columns}
                    rowTemplate={rowTemplate}
                    placeHolder={placeholderText()}
                />
            ) : (
                <Table
                    loading={loading}
                    dataForRows={
                        processedRequests
                            .filter((responseRow) => {
                                return responseRow.colaborador
                                    .toLowerCase()
                                    .replace(/\s/g, "")
                                    .includes(searchField.toLowerCase().replace(/\s/g, ""));
                            })
                            .sort((a, b) => a.colaborador.localeCompare(b.colaborador))
                    }
                    columns={columnsProcessed} // You can define different columns for the second table if needed
                    rowTemplate={rowTemplateProcessed} // You can define a different rowTemplate for the second table if needed
                    placeHolder={placeholderText()}
                />
            )}
        </div>
        </>
    )
};
